import * as React from 'react';
import { DateInput } from 'components/date-input'
import {IFiltersDateInput} from '../filter.interface';

export const FiltersDateInput = (props:IFiltersDateInput) => {

    return (<div className="col-25" >
        <DateInput
            id={props.id?props.id : `filter-date-input-${props.name}`}
            onChange={props.onChange as (value: string) => void}
            setValidity={props.setValidity}
            value={props.value as string}
            relatedField={props.relatedField}
            isInvalid={props.isInvalid}
            minValue={props.minValue}
            readOnly={props.readOnly}
            placeholder={props.placeholder}
            {...props}
        />
    </div >)
}